/**
 * Arabic for Visual docking — the docking guidance unit at the head of each
 * stand. Proposed; pending native aviation review. STOP, VDGS and ICAO type
 * codes are kept as the displays and the manuals carry them.
 */
const ar: Record<string, string> = {
  "Docking guidance performance: the first dial is all {n} units on the main terminal stands 101–121 together; the next three are what it is made of — guiding, stopping on the mark, calibration in date. Open a dial for the units behind it, worst first; the Visual docking screen has every stand.":
    "أداء توجيه الرسو: المؤشر الأول هو الوحدات الـ{n} على مواقف المبنى الرئيسي 101–121 مجتمعة؛ والثلاثة التالية مكوناته — التوجيه، والتوقف على العلامة، وسريان المعايرة. افتح أي مؤشر لترى الوحدات التي خلفه، الأسوأ أولاً؛ وشاشة التوجيه المرئي للرسو تعرض كل موقف.",
  "Guided dockings in the last 24 hours that stopped within {c} cm of the mark.":
    "عمليات الرسو الموجّهة خلال آخر 24 ساعة التي توقفت ضمن {c} سم من العلامة.",
  Guiding: "توجّه",
  "Units bringing aircraft in themselves; a degraded unit counts at 70%.":
    "الوحدات التي توجّه الطائرات بنفسها؛ وتُحسب الوحدة ذات الأداء المنخفض بنسبة 70%.",
  "Units whose calibration is within its interval.": "الوحدات التي لا تزال معايرتها ضمن فترتها.",
  "{d} of {n} out of date": "{d} من {n} منتهية",
  "{g} of {n} guiding": "{g} من {n} توجّه",
  "{n} dockings · {a} aborted": "{n} عمليات رسو · {a} ملغاة",
  "{p}% on the mark": "{p}% على العلامة",
  "Main terminal": "المبنى الرئيسي",
  "Visual docking: {p}% across {n} units on every apron; {d} not guiding.":
    "التوجيه المرئي للرسو: {p}% عبر {n} وحدة في كل الساحات؛ {d} لا توجّه.",
  "Visual docking: no docking unit on record.": "التوجيه المرئي للرسو: لا توجد وحدة رسو مسجلة.",
  "How is docking doing?": "كيف أداء الرسو؟",
  "All VDGS": "كل أنظمة توجيه الرسو",
  "Docking guidance performance across every apron and stand, from the Visual docking register.":
    "أداء توجيه الرسو عبر كل الساحات والمواقف، من سجل التوجيه المرئي للرسو.",
  "From the docking register kept on Visual docking: each unit guiding or not, its stops on the mark over the last day (60%) and its calibration in date (40%); a degraded unit counts at 70%. Proposed weighting.":
    "من سجل وحدات الرسو في شاشة التوجيه المرئي للرسو: هل توجّه كل وحدة أم لا، وتوقفاتها على العلامة خلال اليوم الأخير (60%)، وسريان معايرتها (40%)؛ وتُحسب الوحدة ذات الأداء المنخفض بنسبة 70%. أوزان مقترحة.",
  "no docking unit on record": "لا توجد وحدة رسو مسجلة",
  "{d} of {n} down": "{d} من {n} متوقفة",
  "Performance gauge on Instruments →": "مؤشر الأداء في شاشة الأجهزة ←",
  "across {n} units on every apron — the gauge on Instruments": "عبر {n} وحدة في كل الساحات — المؤشر في شاشة الأجهزة",
  "docking performance": "أداء الرسو",
  "performance {p}%": "الأداء {p}%",
  "Apron 1": "الساحة 1",
  "Gauges · visual docking": "مؤشرات · التوجيه المرئي للرسو",
  "Visual docking": "التوجيه المرئي للرسو",
  "The docking guidance unit at the head of every stand, apron by apron: whether it is guiding and what its display shows, who is on the stand and who comes next, the arrivals that will need a marshaller and why, calibration and emergency-stop tests, the aircraft types each unit knows, the last day's dockings with their stop error, and a work order raised against the unit.":
    "وحدة توجيه الرسو في رأس كل موقف، ساحةً ساحة: هل توجّه الطائرات وماذا تعرض شاشتها، ومن على الموقف ومن التالي، والرحلات القادمة التي ستحتاج إلى موجّه أرضي ولماذا، والمعايرة واختبار التوقف الطارئ، وأنواع الطائرات التي تعرفها كل وحدة، وعمليات الرسو في اليوم الأخير مع خطأ التوقف لكل منها، وأمر عمل يُفتح على الوحدة.",
  "An aborted docking in 24 hours": "رسو واحد أُلغي خلال 24 ساعة",
  "Calibration due in {n} days": "المعايرة مستحقة خلال {n} يوماً",
  "Calibration overdue by {n} days": "المعايرة متأخرة {n} يوماً",
  "Degraded: {what}": "أداء منخفض: {what}",
  "Fault: {what}": "عطل: {what}",
  "Guiding, with a reported problem": "توجّه، مع مشكلة مُبلَّغ عنها",
  "No calibration on record": "لا توجد معايرة مسجلة",
  "Only {p}% of dockings on the mark": "{p}% فقط من عمليات الرسو على العلامة",
  "Out for maintenance": "خارج الخدمة للصيانة",
  "Reported faulty": "مُبلَّغ عن عطل",
  "{n} aborted dockings in 24 hours": "{n} عمليات رسو أُلغيت خلال 24 ساعة",
  "Add type": "إضافة نوع",
  "Aircraft types taught": "أنواع الطائرات المُدرَّبة عليها",
  "Bridge interlock": "ربط الجسر",
  "Calibrated today": "عُويِرت اليوم",
  Calibration: "المعايرة",
  "Demonstration register. The calibration interval ({d} days) and the stop tolerance ({c} cm) are proposed defaults for the airport to confirm; the unit's own maintenance manual governs.":
    "سجل للعرض التوضيحي. فترة المعايرة ({d} يوماً) وسماحية التوقف ({c} سم) قيم افتراضية مقترحة يؤكدها المطار؛ ويبقى دليل صيانة الوحدة هو المرجع.",
  "Docking guidance, stand {s}: {what}": "توجيه الرسو، الموقف {s}: {what}",
  "Emergency stop tested today": "اختُبر التوقف الطارئ اليوم",
  "Emergency stop tested": "اختبار التوقف الطارئ",
  "Every arrival in the next hours has a docking unit that will guide it.":
    "كل رحلة قادمة في الساعات المقبلة لها وحدة رسو ستوجّهها.",
  "ICAO type, e.g. A332": "نوع إيكاو، مثل A332",
  "Last calibrated": "آخر معايرة",
  "Marshalled by hand": "توجيه يدوي",
  "Next arrival: {f} at {t}": "الوصول التالي: {f} الساعة {t}",
  "No dockings logged.": "لا توجد عمليات رسو مسجلة.",
  "No unit recorded": "لا توجد وحدة مسجلة",
  "Nothing to show on this apron.": "لا شيء للعرض في هذه الساحة.",
  "Open work": "أعمال مفتوحة",
  "Raised {n}": "فُتح {n}",
  "Save status": "حفظ الحالة",
  Seconds: "ثوانٍ",
  "Stand plan →": "خطة المواقف ←",
  "Stand {s} ({apron})": "الموقف {s} ({apron})",
  "Stand {s} — docking unit": "الموقف {s} — وحدة الرسو",
  "Stop error": "خطأ التوقف",
  "The docking guidance at the head of every stand, apron by apron: whether it is guiding, what it shows, who is on the stand and who comes next — and which arrivals will need a marshaller.":
    "توجيه الرسو في رأس كل موقف، ساحةً ساحة: هل يوجّه، وماذا يعرض، ومن على الموقف ومن التالي — وأي الرحلات القادمة ستحتاج إلى موجّه أرضي.",
  "The last day's dockings": "عمليات الرسو في اليوم الأخير",
  "What the display shows": "ما تعرضه الشاشة",
  "Which stands need a marshaller?": "أي المواقف تحتاج إلى موجّه أرضي؟",
  "aborted dockings": "عمليات رسو ملغاة",
  "arrivals in the next {h} hours onto a stand that cannot guide them":
    "رحلات قادمة خلال {h} ساعات إلى موقف لا يستطيع توجيهها",
  "arrivals in the next {h} hours": "رحلات قادمة خلال {h} ساعات",
  "calibration due": "معايرة مستحقة",
  "due {d}": "مستحقة {d}",
  empty: "فارغ",
  "fault or maintenance": "عطل أو صيانة",
  "in the last 24 hours": "خلال آخر 24 ساعة",
  "inspect and calibrate": "فحص ومعايرة",
  "marshaller needed": "مطلوب موجّه أرضي",
  "no gate": "بلا بوابة",
  "not bringing aircraft in": "لا توجّه الطائرات",
  "nothing planned": "لا شيء مخطط",
  "of {n} dockings in 24 h, within {c} cm": "من {n} عملية رسو خلال 24 ساعة، ضمن {c} سم",
  "of {n} fitted, on {s} stands": "من {n} مركّبة، على {s} موقفاً",
  "on the mark": "على العلامة",
  "overdue {n} days": "متأخرة {n} يوماً",
  "overdue, or within 14 days": "متأخرة، أو خلال 14 يوماً",
  remote: "بعيد",
  "the docking unit register": "سجل وحدات الرسو",
  "type not taught": "النوع غير مُدرَّب",
  "units guiding": "وحدات توجّه",
  "until {t}": "حتى {t}",
  "what is wrong, or what was done": "ما العطل، أو ما الذي أُنجز",
  "yes — the bridge waits for STOP": "نعم — ينتظر الجسر إشارة STOP",
  "{g} of {f} docking units guiding across {s} stands.": "{g} من {f} وحدات رسو توجّه عبر {s} موقفاً.",
  "{n} aborted": "{n} ملغاة",
  "{n} arrivals in the next {h} hours need a marshaller.": "{n} رحلات قادمة خلال {h} ساعات تحتاج إلى موجّه أرضي.",
  "{n} dockings": "{n} عمليات رسو",
  "{n} stands · {g} guided": "{n} مواقف · {g} بتوجيه آلي",
  "{n} units due or overdue for calibration.": "{n} وحدات مستحقة أو متأخرة المعايرة.",
  "Advanced VDGS (laser)": "نظام توجيه رسو متقدم (ليزر)",
  "VDGS (parallax / optical)": "نظام توجيه رسو (بصري)",
  "Marshaller only": "موجّه أرضي فقط",
  "Not fitted": "غير مركّب",
  Fault: "عطل",
  "No unit": "لا توجد وحدة",
  "On the mark": "على العلامة",
  "Stopped short": "توقف قبل العلامة",
  "Overran the mark": "تجاوز العلامة",
  Aborted: "أُلغي",
  "The docking unit is not guiding": "وحدة الرسو لا توجّه",
  "No docking unit on this stand": "لا توجد وحدة رسو على هذا الموقف",
  "This aircraft type is not in the unit's database": "نوع الطائرة هذا غير موجود في قاعدة بيانات الوحدة",
  "Main terminal apron · 101–121": "ساحة المبنى الرئيسي · 101–121",
  "Cargo apron": "ساحة الشحن",
  "General aviation apron": "ساحة الطيران العام",
  "Maintenance apron": "ساحة الصيانة",
  "Marshaller needed": "مطلوب موجّه أرضي",
  "All aprons": "كل الساحات",
  "Every stand": "كل المواقف",
  "Not guiding": "لا توجّه",
  Apron: "الساحة",
};

export default ar;
